export default __webpack_public_path__ + "static/media/LSP6.7dacb37d.jpeg";